import { useEffect } from 'react';

export default function StructuredData() {
  useEffect(() => {
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "TAMA & ORAL Hukuk Bürosu",
      "image": "https://tamaoral.av.tr/logo.png",
      "description": "TAMA & ORAL Hukuk Bürosu - İzmir'de profesyonel avukat ve hukuki danışmanlık hizmetleri. İcra takibi, aile hukuku, ticari hukuk, gayrimenkul hukuku ve daha fazlası.",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Mansuroğlu Mah. 286/1 Sok. No:16 Ata Plaza K:7 D:28",
        "addressLocality": "Bayraklı",
        "addressRegion": "İzmir",
        "postalCode": "35000",
        "addressCountry": "TR"
      },
      "telephone": [
        "+905379371064",
        "+902324866301"
      ],
      "email": "info@tamaoral.av.tr",
      "url": "https://tamaoral.av.tr",
      "priceRange": "$$",
      "areaServed": [
        {
          "@type": "City",
          "name": "İzmir"
        },
        {
          "@type": "City",
          "name": "Bayraklı"
        }
      ],
      "sameAs": [
        "https://x.com/tamaoralavtr",
        "https://instagram.com/tamaoralavtr"
      ],
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "09:00",
          "closes": "18:00"
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.innerHTML = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return null;
}
